import { render, staticRenderFns } from "./IconButtonClose2.vue?vue&type=template&id=613e427e&scoped=true&"
import script from "./IconButtonClose2.vue?vue&type=script&lang=js&"
export * from "./IconButtonClose2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613e427e",
  null
  
)

export default component.exports